import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import config from '../config/environment';

// Create an HTTP link to your WordPress GraphQL endpoint
const httpLink = createHttpLink({
  uri: config.graphqlEndpoint,
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  fetchOptions: {
    mode: 'cors',
  },
});

// Create the Apollo Client instance
const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default client; 